import React, { useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import TabsList from "molecules/TabsList";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
} from "antd";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";

const Styleddiv = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #1f243b;
  }
  .performance-appraisal {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    cursor: pointer;
  }
  .right-icon {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
  }
  .evaluated-response {
    font-weight: 500;
    font-size: 20px;
  }
  .ant-tabs-tab {
    font-size: 16px;
    font-weight: 500;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .key-responsibilities {
    font-size: 16px;
    font-weight: 600;
  }
`;
const Tabledata = styled.div`
  .heading {
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    padding-left: 8px;
    color: #636980;
  }
  .score {
    font-size: 16px;
    font-weight: 400;
  }
  .score-card {
    background: #f8f8f8;
    padding: 10px;
  }
  .score-card-classificaton {
    display: flex;
    justify-content: space-between;
  }
  .score-classification {
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    text-decoration: underline;
    color: #126df6;
  }
`;
const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .item-score {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .item-description {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
`;
const footerStyle = {
  position: "sticky",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#fff",
  padding: "10px",
  display: "flex",
  justifyContent: "end",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  margin: "0px -20px",
};
const Wrap = styled.div`
  .ant-input {
    border: none;
    background: none;
  }
`;
const items = [
  {
    label: "Basic Score Card",
    id: 1,
  },
  {
    label: "Other Evaluations",
    id: 2,
  },
  {
    label: "Recommendations",
    id: 3,
  },
];

const Evaluated = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState(1);
  const handleTabSelect = (key) => {
    setActiveTab(key);
  };
  const [isScoreModal, setIsScoreModal] = useState(false);

  const scoreData = [
    { score: "6", description: "Exceptional performance", color: "#03C83E" },
    {
      score: "5",
      description: "Exceeds minimum requirements",
      color: "#7DCA4ACC",
    },
    {
      score: "4",
      description: "Meets all minimum requirements",
      color: "#FFFF68",
    },
    {
      score: "3",
      description: "Typically meets minimum requirements",
      color: "#ED7D31CC",
    },
    {
      score: "2",
      description: "Does not meet minimum requirements",
      color: "#FF0000CC",
    },
    { score: "1", description: "Unacceptable performance", color: "#C00000CC" },
  ];
  const columns = [
    {
      title: "S.No",
      dataIndex: "s_no",
      key: "s_no",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Target objectives given during previous appraisal",
      dataIndex: "targetObjective",
      key: "targetObjective",
      render: (_, record) => <p>Better team Management</p>,
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      render: (_, record) => <p>Well performed</p>,
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      render: (_, record) => <p>24th Aug 2024</p>,
    },
    {
      title: "Agreed remedial Actions",
      dataIndex: "agreedActions",
      key: "agreedActions",
      render: (_, record) => (
        <Form.Item
          name={["agreedActions", record.key]}
          rules={[
            { required: true, message: "Please enter Agreed remedial Actions" },
          ]}
        >
          <Input placeholder="Enter..." />
        </Form.Item>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      render: (_, record) => (
        <Form.Item
          name={["expectedOutcomes", record.key]}
          rules={[
            { required: true, message: "Please enter Expected Outcomes" },
          ]}
        >
          <Input placeholder="Enter..." />
        </Form.Item>
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      render: (_, record) => (
        <Form.Item
          name={["targetDate", record.key]}
          rules={[{ required: true, message: "Please select target date" }]}
        >
          <DatePicker placeholder="Choose" />
        </Form.Item>
      ),
    },
  ];

  const [dataSource, setDataSource] = useState([
    {
      key: "1",
      targetObjective: "",
      expectedOutcomes: "",
      targetDate: null,
      agreedActions: "",
      expectedOutcomes: "",
      targetDate: "",
    },
    {
      key: "2",
      targetObjective: "",
      expectedOutcomes: "",
      targetDate: null,
      agreedActions: "",
      expectedOutcomes: "",
      targetDate: "",
    },
  ]);

  const handleAddRow = () => {
    if (dataSource.length < 10) {
      setDataSource([
        ...dataSource,
        {
          key: (dataSource.length + 1).toString(),
          targetObjective: "",
          expectedOutcomes: "",
          targetDate: null,
          agreedActions: "",
          expectedOutcomes: "",
          targetDate: "",
        },
      ]);
    }
  };
  //   const dataSource = [
  //     {
  //       key: "1",
  //       //   s_no: 1,
  //       targetObjective: "Better team Management",
  //       //   expectedOutcomes: "Well performed",
  //       targetDate: "24th Aug 2024",
  //       //   agreedActions: "Enter...",
  //     },
  //     {
  //       key: "2",
  //       //   s_no: 2,
  //       targetObjective: "Better team Management",
  //       //   expectedOutcomes: "Well performed",
  //       targetDate: "24th Aug 2024",
  //       //   agreedActions: "Enter...",
  //     },
  //   ];

  return (
    <>
      <Styleddiv>
        <div className="breadcrumb">
          <p
            className="performance-appraisal"
            onClick={() => {
              history.push("/performancemanagement");
            }}
          >
            Performance Management
          </p>
          <RightOutlined className="right-icon" />
          <p
            className="performance-appraisal"
            onClick={() => {
              history.goBack();
            }}
          >
            Appraisal - Mid Year
          </p>
          <RightOutlined className="right-icon" />
          <p>John Steve</p>
        </div>
        <div className="evaluated-response">Evaluated Response</div>
        <TabsList
          items={items}
          activeTab={activeTab}
          handleTabSelect={handleTabSelect}
        />
        <div>
          {activeTab === 1 && (
            <>
              <div>
                <h6>Individual Assessment</h6>
                <Row gutter={12}>
                  <Col xs={24} md={12}>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Client Survey Average Score
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        VTP Appraisal Average Score
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        LMS – 40 hrs (target to actual %)
                      </div>
                      <div className="col-value">90</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Non–Chargeable %</div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        No. of Credentials Inputted
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Avg Time-sheet approval delays in days
                      </div>
                      <div className="col-value">3</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        No. of assignments worked on
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Employee Profit/Loss</div>
                      <div className="col-value">Profit</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">No.of leads Created</div>
                      <div className="col-value">35</div>
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Engagement Appraisal Average Score
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Leaves Taken (Days)</div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Chargeability (Target to Actual %)
                      </div>
                      <div className="col-value">30</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">CV Last Updated (Date)</div>
                      <div className="col-value">25th Aug 2024</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Avg Time-sheet delays in days
                      </div>
                      <div className="col-value">2</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Average Task Delays in Days (VTP)
                      </div>
                      <div className="col-value">2</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Employee Billing</div>
                      <div className="col-value">---</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Amounts of Proposal in the pipeline
                      </div>
                      <div className="col-value">$50</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Proposal Conversion Rates(%)
                      </div>
                      <div className="col-value">80</div>
                    </div>
                  </Col>
                </Row>
                <br />
                <br />
                <h6>Departmental/ Country/ Cluster level assessment</h6>
                <Row gutter={12}>
                  <Col xs={24} md={12}>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Revenue, Rev vs budget, and GOLY%
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Rev/ Profit per employee</div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">Debtors in USD and days</div>
                      <div className="col-value">90</div>
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Departmental Profit, vs budget, GOLY %
                      </div>
                      <div className="col-value">20</div>
                    </div>
                    <div className="rows pt-2 pb-2">
                      <div className="col-label">
                        Employee cost, Profits as a %age of rev
                      </div>
                      <div className="col-value">3200</div>
                    </div>
                  </Col>
                </Row>
                <br />
                <Tabledata>
                  <Row gutter={16}>
                    <Col xl={24}>
                      <div className="score-card-classificaton">
                        <b>Employee Score Card</b>
                        <p
                          className="score-classification"
                          type="link"
                          onClick={() => setIsScoreModal(true)}
                        >
                          Score Classification
                        </p>
                      </div>
                      <div className="">
                        <Form
                          form={form}
                          //   key={val?.roletype}
                          //   name={val?.roletype}
                          layout="vertical"
                        //   onFinish={(values) =>
                        //     handleFormSubmit(values, val?.roletype)
                        //   }
                        >
                          {/* <br></br> */}
                          <div className="score-card">
                            <Row className="mt-2" gutter={20}>
                              <Col xs={24} sm={24} md={12}>
                                <label className="heading">
                                  Individual Assess Automatic Score{" "}
                                </label>
                                <span className="score"> &nbsp; 30 </span>

                                <Form.Item
                                  name="appraisalscore"
                                  label="Individual Assess Appraiser's Score"
                                  placeholder="Select Individual Assess Appraiser's Score"
                                  rules={[
                                    {
                                      required: true,
                                      //     itsPrimaryUser &&
                                      //     selectedSegment !== "Primary"
                                      //       ? false
                                      //       : true,
                                      //   pattern: NON_EMPTY_REGEX,
                                      message:
                                        "Individual Assess Appraiser's Score is required",
                                    },
                                  ]}
                                >
                                  <Select>
                                    <Select.Option value="1">1</Select.Option>
                                    <Select.Option value="2">2</Select.Option>
                                    <Select.Option value="3">3</Select.Option>
                                    <Select.Option value="4">4</Select.Option>
                                    <Select.Option value="5">5</Select.Option>
                                    <Select.Option value="6">6</Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name="appraisalremarks"
                                  label="Individual Assess Appraiser's Remark"
                                  placeholder="Select Individual Assess Appraiser's Remark"
                                  rules={[
                                    {
                                      required: true,
                                      //     itsPrimaryUser &&
                                      //     selectedSegment !== "Primary"
                                      //       ? false
                                      //       : true,
                                      //   pattern: NON_EMPTY_REGEX,
                                      message:
                                        "Individual Assess Appraiser's Remark is required",
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Individual Assess Appraiser's Remark"
                                    maxLength={50}
                                  // disabled={
                                  //   itsPrimaryUser &&
                                  //   selectedSegment !== "Primary"
                                  //     ? true
                                  //     : false
                                  // }
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={12}>
                                <label className="heading">
                                  Dept Level Assess Automatic Score{" "}
                                </label>{" "}
                                <span className="score"> &nbsp; 30 </span>
                                <Form.Item
                                  name="deptlevelappraisalscore"
                                  label="Dept Level Assess Appraiser's Score"
                                  placeholder="Select Dept Level Assess Appraiser's Score"
                                  rules={[
                                    {
                                      required: true,
                                      //     itsPrimaryUser &&
                                      //     selectedSegment !== "Primary"
                                      //       ? false
                                      //       : true,
                                      //   pattern: NON_EMPTY_REGEX,
                                      message:
                                        "Dept Level Assess Appraiser's Score is required",
                                    },
                                  ]}
                                >
                                  <Select>
                                    <Select.Option value="1">1</Select.Option>
                                    <Select.Option value="2">2</Select.Option>
                                    <Select.Option value="3">3</Select.Option>
                                    <Select.Option value="4">4</Select.Option>
                                    <Select.Option value="5">5</Select.Option>
                                    <Select.Option value="6">6</Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name="deptlevelappraisalremarks"
                                  label="Dept Level Assess Appraiser's Remark"
                                  placeholder="Select Dept Level Assess Appraiser's Score"
                                  rules={[
                                    {
                                      required: true,
                                      //     itsPrimaryUser &&
                                      //     selectedSegment !== "Primary"
                                      //       ? false
                                      //       : true,
                                      //   pattern: NON_EMPTY_REGEX,
                                      message:
                                        "Dept Level Assess Appraiser's Score is required",
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Dept Level Assess Appraiser's Remark"
                                    maxLength={50}
                                  // disabled={
                                  //   itsPrimaryUser &&
                                  //   selectedSegment !== "Primary"
                                  //     ? true
                                  //     : false
                                  // }
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>

                          <div style={footerStyle}>
                            <ButtonOutlined
                              style={{ width: "130px", height: "35x" }}
                            //   onClick={() =>
                            //     history.push(`/viewmyteamAppraisal/${id}`)
                            //   }
                            >
                              Cancel
                            </ButtonOutlined>
                            {/* {appraisalIndex !== 1 && (
                              <ButtonOutlined
                                onClick={() => {
                                  const currentIndex =
                                    appraisalInformation?.findIndex(
                                      (item) =>
                                        item.roletype === selectedSegment
                                    );

                                  if (currentIndex > 0) {
                                    setSelectedSegment(
                                      appraisalInformation[currentIndex - 1]
                                        ?.roletype
                                    );
                                    setAppraisalIndex(currentIndex + 1);
                                    setCompletedSegment((prev) => {
                                      if (!prev.includes(currentIndex)) {
                                        return [...prev, currentIndex - 1];
                                      }
                                      return prev;
                                    });
                                    setTabId(3);
                                  }
                                }}
                              >
                                Previous
                              </ButtonOutlined>
                            )} */}

                            <ButtonFilled
                              style={{ width: "130px", height: "35x" }}
                              type="primary"
                              htmlType="submit"
                            >
                              Next
                            </ButtonFilled>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </Tabledata>
              </div>
            </>
          )}
          {activeTab === 2 && (
            <>
              <Row gutter={16}>
                <Col xl={24} sm={24}>
                  <div className="key-responsibilities">
                    <p>Key responsibilities / Target / Strategic objectives</p>
                  </div>
                  <Wrap>
                    <Table
                      columns={columns}
                      dataSource={dataSource}
                      pagination={false}
                      footer={() => (
                        <div>
                          <Button
                            style={{ border: "none" }}
                            onClick={handleAddRow}
                            disabled={dataSource.length >= 10}
                          >
                            <span style={{ textDecoration: "underline" }}>
                              + Add another (Max 10 rows)
                            </span>
                          </Button>
                        </div>
                      )}
                    />
                  </Wrap>
                </Col>
              </Row>
            </>
          )}
          {activeTab === 3 && (
            <>
              <div>c</div>
            </>
          )}
        </div>
        <StyledModal
          title="Score Classification"
          open={isScoreModal}
          footer={null}
          onCancel={() => setIsScoreModal(false)}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              borderRadius: "8px",
            }}
          >
            <tbody>
              {scoreData.map((item, index) => (
                <tr
                  key={index}
                  style={{ backgroundColor: item.color, color: "#fff" }}
                >
                  <td className="item-score">{item.score}</td>
                  <td className="item-description">{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </StyledModal>
      </Styleddiv>
    </>
  );
};

export default Evaluated;
